import styled from "styled-components";

const ModalBody = styled.div`
    p, li {
        margin: 0;
    }

    li {
        list-style: disc;
    }
`

const Divider = styled.span`
    display: block;
    margin: 14px 0;
`

export {ModalBody, Divider}